import { useState } from "react";
import axios from "axios.js";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
// import BasicLayout from "app/user/components/BasicLayout";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

import { useIsAuthenticated } from "react-auth-kit";
import { Formik } from "formik";
import * as Yup from "yup";
import { Snackbar, TextField, Alert, Backdrop, CircularProgress, Card } from "@mui/material";
// import { LoadingButton } from "@mui/lab";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

// inital login credentials
const initialValues = {
  email: "",
};

// form field validation schema
const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid Email address").required("Email is required!"),
});

function ForgotPwd() {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated()) {
    navigate("/home");
  }
  usePageTitle("Forgot Password");

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const handleFormSubmit = async (values) => {
    setShowLoading(true);
    try {
      const json = { email_address: values.email };
      const response = await axios.post("portal/forgot-password.json", json);
      // console.log(response.data.data.token);
      if (response.data.status === "error") {
        // error = response.data.data.message;
        setOpen(true);
        setShowLoading(false);
        setErrMsg(response.data.data.message);
        setSeverity("error");
      } else {
        setOpen(true);
        setShowLoading(false);
        setErrMsg(response.data.data.message);
        setSeverity("success");
      }
    } catch (e) {
      setShowLoading(false);
      setErrMsg("An error occurred. Please try again later.");
      setSeverity("error");
      setOpen(true);
    }
  };

  return (
    <PageLayout image={bgImage}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox sx={{ margin: "55px auto", maxWidth: 360 }}>
        <Card>
          <MDBox p={2}>
            <MDBox>
              <MDTypography variant="h4" fontWeight="medium" mt={1}>
                Laddar Portal
              </MDTypography>
              <MDTypography display="block" variant="button" my={1}>
                Forgot your password?
              </MDTypography>
            </MDBox>
            <MDBox mt={5}>
              <MDBox role="form">
                <Formik
                  onSubmit={handleFormSubmit}
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                >
                  {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                      <MDBox mb={2}>
                        {/* <MDInput type="email" label="Email" fullWidth /> */}
                        <TextField
                          fullWidth
                          size="small"
                          type="email"
                          name="email"
                          label="Email"
                          variant="outlined"
                          onBlur={handleBlur}
                          value={values.email}
                          onChange={handleChange}
                          helperText={touched.email && errors.email}
                          error={Boolean(errors.email && touched.email)}
                          sx={{ mb: 3 }}
                        />
                      </MDBox>
                      <MDBox mt={2} mb={1}>
                        <MDButton
                          variant="gradient"
                          color={AppConfig.sidenav_active_menu_color}
                          type="submit"
                          fullWidth
                        >
                          Reset Password
                        </MDButton>
                      </MDBox>
                      <MDBox mt={3} mb={1} textAlign="center">
                        <MDTypography variant="button" color="text">
                          Already have an account?{" "}
                          <MDTypography
                            component={Link}
                            to="/user/sign-in"
                            variant="button"
                            color={AppConfig.sidenav_active_menu_color}
                            fontWeight="medium"
                            textGradient
                          >
                            Sign In
                          </MDTypography>
                        </MDTypography>
                      </MDBox>
                    </form>
                  )}
                </Formik>
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </PageLayout>
  );
}

export default ForgotPwd;
